import React from "react";
import * as Sentry from "@sentry/react";

interface Props {
  children: React.ReactNode;
}

const ErrorBoundaryComponent: React.FC<Props> = ({ children }) => {
  return <Sentry.ErrorBoundary>{children}</Sentry.ErrorBoundary>;
};

export default ErrorBoundaryComponent;
